module.exports = __webpack_public_path__ + "static/media/board_view_campus_img_c.3717a0ad.png";